// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__0DO62","navbar":"Navbar_navbar__1sSuW","logo":"Navbar_logo__o8J8F"};